import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = {
  key: 0,
  class: "row m-auto"
}
const _hoisted_4 = { class: "col-md-12 px-5 py-2 financial-calendar" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-12 col-md-12" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "col-sm-12 mt-2 mb-1"
}
const _hoisted_10 = {
  key: 1,
  class: "col-sm-12 mt-2 mb-1"
}
const _hoisted_11 = { class: "col-12 px-0" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table mb-0" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = {
  key: 0,
  class: "bg-light"
}
const _hoisted_16 = {
  key: 1,
  class: "bg-light fw-normal"
}
const _hoisted_17 = { class: "pe-5 py-0 text-end text-secondary" }
const _hoisted_18 = {
  key: 2,
  class: "bg-light fw-normal"
}
const _hoisted_19 = { class: "pe-5 py-0 text-end text-secondary" }
const _hoisted_20 = {
  key: 3,
  class: "bg-light"
}
const _hoisted_21 = { class: "pe-5 text-end text-secondary" }
const _hoisted_22 = {
  key: 4,
  class: "bg-light"
}
const _hoisted_23 = { class: "pe-5 text-end text-secondary" }
const _hoisted_24 = {
  key: 5,
  class: "bg-light"
}
const _hoisted_25 = { class: "pe-5 text-end text-secondary" }
const _hoisted_26 = {
  key: 6,
  class: "bg-light"
}
const _hoisted_27 = { class: "pe-5 text-end text-secondary" }
const _hoisted_28 = {
  key: 7,
  class: "bg-light"
}
const _hoisted_29 = { class: "pe-5 text-end text-secondary" }
const _hoisted_30 = {
  key: 8,
  class: "bg-light"
}
const _hoisted_31 = { class: "pe-5 text-end text-secondary" }
const _hoisted_32 = {
  key: 9,
  class: "bg-light"
}
const _hoisted_33 = { class: "pe-5 text-end text-secondary" }
const _hoisted_34 = { class: "ps-5 py-0" }
const _hoisted_35 = { class: "pe-5 py-0 text-end text-secondary" }
const _hoisted_36 = {
  key: 0,
  class: "pe-5 bg-white text-end text-primary"
}
const _hoisted_37 = {
  key: 1,
  class: "pe-5 bg-white text-end text-primary"
}
const _hoisted_38 = {
  key: 1,
  class: "loading-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Financial Overview", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("select", {
                    class: "border-0 text-secondary me-2",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query_month) = $event))
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['01','02','03','04','05','06','07','08','09','10','11','12'], (ind) => {
                      return _createElementVNode("option", {
                        key: ind,
                        value: ind
                      }, _toDisplayString(_ctx.moment('2021-' + ind + '-01 00:00:00').format('MMMM')), 9, _hoisted_7)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, _ctx.query_month]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "border-0 text-secondary me-2",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query_year) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: year,
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_8))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.query_year]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-xs mb-1 float-end",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getFinancialData()))
                  }, "Update")
                ]),
                (_ctx.store.getters.hasPermission('financial_report.access') && _ctx.is_admin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn btn-primary btn-xs float-end",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({name:'financial.report'})))
                      }, "View Full Report")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.store.getters.hasPermission('financial_report.access') && _ctx.is_admin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "btn btn-primary btn-xs float-end",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({name:'payment.report'})))
                      }, "View Payment Report")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("tbody", _hoisted_14, [
                    (!_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("td", {
                            class: _normalizeClass(["ps-5", _ctx.store.getters.user.props.super_admin || (_ctx.store.getters.hasRole(_ctx.UserRole.SP) && _ctx.store.getters.hasRole(_ctx.UserRole.OBSERVER)) || _ctx.store.getters.hasRole(_ctx.UserRole.ADMIN) ? 'pb-0' : ''])
                          }, "Visits", 2),
                          _createElementVNode("td", {
                            class: _normalizeClass(["pe-5 text-end text-secondary", _ctx.store.getters.user.props.super_admin || (_ctx.store.getters.hasRole(_ctx.UserRole.SP) && _ctx.store.getters.hasRole(_ctx.UserRole.OBSERVER)) || _ctx.store.getters.hasRole(_ctx.UserRole.ADMIN) ? 'pb-0' : ''])
                          }, "$" + _toDisplayString(_ctx.visits), 3)
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.store.getters.user.props.super_admin || (_ctx.store.getters.hasRole(_ctx.UserRole.SP) && _ctx.store.getters.hasRole(_ctx.UserRole.OBSERVER)) || _ctx.store.getters.hasRole(_ctx.UserRole.ADMIN)) && !_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                          _cache[5] || (_cache[5] = _createElementVNode("td", { class: "ps-5 py-0" }, [
                            _createElementVNode("small", null, "– SP")
                          ], -1)),
                          _createElementVNode("td", _hoisted_17, [
                            _createElementVNode("small", null, "$" + _toDisplayString(_ctx.sp_visits), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.store.getters.user.props.super_admin || (_ctx.store.getters.hasRole(_ctx.UserRole.SP) && _ctx.store.getters.hasRole(_ctx.UserRole.OBSERVER)) || _ctx.store.getters.hasRole(_ctx.UserRole.ADMIN)) && !_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                          _cache[6] || (_cache[6] = _createElementVNode("td", { class: "ps-5 py-0" }, [
                            _createElementVNode("small", null, "– Observer")
                          ], -1)),
                          _createElementVNode("td", _hoisted_19, [
                            _createElementVNode("small", null, "$" + _toDisplayString((_ctx.observer_visits)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                          _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ps-5" }, "Training Sessions", -1)),
                          _createElementVNode("td", _hoisted_21, "$" + _toDisplayString((_ctx.training_sessions)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                          _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ps-5" }, "Late Cancellations", -1)),
                          _createElementVNode("td", _hoisted_23, "$" + _toDisplayString(_ctx.late_cancellations), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                          _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ps-5" }, "Early Cancellations", -1)),
                          _createElementVNode("td", _hoisted_25, "$" + _toDisplayString(_ctx.early_cancellations), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                          _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ps-5" }, "No Shows", -1)),
                          _createElementVNode("td", _hoisted_27, "$" + _toDisplayString(_ctx.no_shows), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                          _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ps-5" }, "Learner Technical Issues", -1)),
                          _createElementVNode("td", _hoisted_29, "$" + _toDisplayString(_ctx.learner_technical_issues), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.interviews && !_ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                          _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ps-5" }, "Interviews", -1)),
                          _createElementVNode("td", _hoisted_31, "$" + _toDisplayString(_ctx.interviews), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.is_admin && _ctx.authoring) || _ctx.is_author)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                          _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ps-5" }, "Authoring Royalties", -1)),
                          _createElementVNode("td", _hoisted_33, "$" + _toDisplayString(_ctx.authoring), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authoring_scenarios, (author_scenario, ind) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: ind,
                        class: "bg-light w-normal"
                      }, [
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("small", null, "– " + _toDisplayString(author_scenario.title) + " (" + _toDisplayString(author_scenario.count) + " x $" + _toDisplayString(author_scenario.rate) + ")", 1)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("small", null, "$" + _toDisplayString(author_scenario.total), 1)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", { class: "ps-5 bg-white" }, "TOTAL", -1)),
                      (!_ctx.is_author)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_36, "$" + _toDisplayString(_ctx.total), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_37, "$" + _toDisplayString(_ctx.authoring), 1))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createVNode(_component_loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}